import cx from "classnames";

import useBreakpointTest from "@/hooks/useBreakpointTest";

import { ArticleBody, ArticleHeader } from ".";
import styles from "./styles.module.css";

export const Article = ({ content }) => {
  const copy = content.articleContent;
  const isDesktop = useBreakpointTest("lg");

  return (
    <article
      className={cx(styles.article, {
        [styles.fullLayout]: content.image_layout === "full",
      })}
    >
      <ArticleHeader content={content} />
      {copy && (
        <>
          <ArticleBody value={copy} />
          {isDesktop ? <hr className={styles.hr} /> : null}
        </>
      )}
    </article>
  );
};
